import type { RangeBarChartConfig } from './types';

// Shaded buffer band between the base average (endRangeValue) and the buffered
// average (rangeValue). Matches amcharts4: axisFill.fill = legend.net, opacity 0.2.
export const buildBufferMarkArea = (rangeValue: number, endRangeValue: number, config: RangeBarChartConfig) => ({
  silent: true,
  itemStyle: { color: config.lineColor, opacity: 0.2 },
  data: [[{ yAxis: rangeValue }, { yAxis: endRangeValue }]],
});
